import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { Table } from 'primeng/table';
import { VendorStock } from 'src/app/models/vendor/vendor-stock';
import { DataService } from "src/app/services/data.service";


@Component({
  selector: 'app-vendor-prod-list',
  templateUrl: './vendor-prod-list.component.html',
  styleUrls: ['./vendor-prod-list.component.scss']
})
export class VendorProdListComponent implements OnInit, OnChanges {

  @Input() title: string;
  @Input() uploadedItems: VendorStock[] = [];

  @ViewChild('filter') filter!: ElementRef;

  public isOpen = false;

  rowGroupMetadata: any;

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    // Populate data initially
    this.dataService.getLatestVendorStock().subscribe({
      next: (data) => {
        this.uploadedItems = data;
        this.isOpen = true;
      },
      error: (err) => {
        console.error('Error loading initial vendor stock data:', err);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['uploadedItems'] && this.uploadedItems?.length > 0) {
      this.isOpen = true;
      console.log('Received stock data:', this.uploadedItems);
    }
  }

  onGlobalFilter(table: Table, event: Event): void {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  clear(table: Table): void {
    table.clear();
    if (this.filter) this.filter.nativeElement.value = '';
  }

  onSort(): void {
    this.updateRowGroupMetaData();
  }

  updateRowGroupMetaData(): void {
    this.rowGroupMetadata = {};
  }

  Download(table: Table): void {
    const filteredData = table.filteredValue || table.value;
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stock_Export');
    XLSX.writeFile(wb, 'StockExport.xlsx');
  }
}
